export const TOOLBAR_PHOTO_GROUP_ENABLE = 'toolbar/TOOLBAR_PHOTO_GROUP_ENABLE';
export const TOOLBAR_PHOTO_GROUP_TOGGLE_PHOTO =
  'toolbar/TOOLBAR_PHOTO_GROUP_TOGGLE_PHOTO';
export const TOOLBAR_PHOTO_GROUP_RESET_PHOTOS =
  'toolbar/TOOLBAR_PHOTO_GROUP_RESET_PHOTOS';
export const TOOLBAR_PHOTO_GROUP_DISMISS =
  'toolbar/TOOLBAR_PHOTO_GROUP_DISMISS';
export const TOOLBAR_PHOTO_GROUP_SELECT_PHOTOS =
  'toolbar/TOOLBAR_PHOTO_GROUP_SELECT_PHOTOS';
export const TOOLBAR_PHOTO_GROUP_DESELECT_PHOTOS =
  'toolbar/TOOLBAR_PHOTO_GROUP_DESELECT_PHOTOS';
export const TOOLBAR_PHOTO_GROUP_DESELECT_ALL =
  'toolbar/TOOLBAR_PHOTO_GROUP_DESELECT_ALL';

export const enablePhotoGroupSelection = photoGroupId => {
  return { type: TOOLBAR_PHOTO_GROUP_ENABLE, photoGroupId };
};

export const selectPhotos = photos => {
  return { type: TOOLBAR_PHOTO_GROUP_SELECT_PHOTOS, photos };
};

export const deselectPhotos = photos => {
  return { type: TOOLBAR_PHOTO_GROUP_DESELECT_PHOTOS, photos };
};

export const deselectAll = () => {
  return { type: TOOLBAR_PHOTO_GROUP_DESELECT_ALL };
};

export const togglePhotoSelection = photoId => {
  return { type: TOOLBAR_PHOTO_GROUP_TOGGLE_PHOTO, photoId };
};

export const resetPhotoSelection = () => {
  return { type: TOOLBAR_PHOTO_GROUP_RESET_PHOTOS };
};

export const dismissPhotoGroupToolbar = () => {
  return { type: TOOLBAR_PHOTO_GROUP_DISMISS };
};
